import React from "react";
import styled from "styled-components/macro";
import { mediaQueries } from "../styles/media.js";
import { JunoDashboardCard, JunoDashboardCardHeader, JunoDashboardCardContent } from "./DashboardCard";

const SkeletonBlock = styled.div`
  background: linear-gradient(
    90deg,
    var(--juno-color-pale-grey) 25%,
    var(--juno-color-off-white) 50%,
    var(--juno-color-pale-grey) 75%
  );
  background-size: 800px 100%;
  border-radius: var(--juno-radius-sm);

  @keyframes shimmer {
    0% {
      background-position: -400px 0;
    }
    100% {
      background-position: 400px 0;
    }
  }

  animation: shimmer 1.4s infinite linear;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

const DelayedAppearance = styled.div`
  opacity: 0;

  @keyframes fadeIn {
    to {
      opacity: 1;
    }
  }

  animation: fadeIn 0s linear 0.2s forwards;
`;

const SkeletonTitle = styled(SkeletonBlock)`
  height: 28px;
  width: 55%;
  ${mediaQueries.md} {
    height: 32px;
  }
`;

const SkeletonLine = styled(SkeletonBlock)`
  height: 16px;
  margin-bottom: var(--juno-space-3);
  width: ${(props) => props.width || "100%"};
`;

function LoadingCard() {
  return (
    <DelayedAppearance>
      <JunoDashboardCard role="status" aria-label="Loading">
        <JunoDashboardCardHeader>
          <SkeletonTitle />
        </JunoDashboardCardHeader>
        <JunoDashboardCardContent>
          <SkeletonLine />
          <SkeletonLine width="75%" />
          <SkeletonLine width="60%" />
        </JunoDashboardCardContent>
      </JunoDashboardCard>
    </DelayedAppearance>
  );
}

export default LoadingCard;
